import { API, graphqlOperation } from 'aws-amplify';
import gql from 'graphql-tag';

interface ListPreferencesResponse {
  listPreferencess: {
    items: any[];
    nextToken: string | null;
  };
}

interface ListPreferencesVariables {
  nextToken: string | null;
  orgID: string;
}

const fetchLeaderboardViews = async (): Promise<any> => {
  const fetchLeaderboardViewQuery = gql`
    query MyQuery($orgID: ID!, $nextToken: String) {
      listPreferencess(
        filter: {
          orgID: { eq: $orgID }
          preferenceType: { eq: "leaderboardView" }
        }
        limit: 999
        nextToken: $nextToken
      ) {
        nextToken
        items {
          id
          name
          orgID
          preferenceType
          preferences
          isHidden
          entityID
        }
      }
    }
  `;

  try {
    let leaderboardViews: any[] = [];
    let nextToken: string | null = null;
    do {
      const leaderboardViewsRes = (await API.graphql(
        graphqlOperation(fetchLeaderboardViewQuery, {
          // @ts-ignore
          orgID: global.me.orgID,
          nextToken,
        } as ListPreferencesVariables)
      )) as { data: ListPreferencesResponse };

      const leaderboardViewItems =
        leaderboardViewsRes.data?.listPreferencess?.items ?? [];
      leaderboardViewItems.forEach((item) => {
        item.preferences = JSON.parse(item.preferences);
      });
      leaderboardViews = [
        ...leaderboardViews,
        ...leaderboardViewItems.filter(
          (view) => !view.isHidden || view.isHidden === false
        ),
      ];
      nextToken = leaderboardViewsRes.data?.listPreferencess?.nextToken;
    } while (nextToken);

    return leaderboardViews;
  } catch (err) {
    console.error('Error fetching leaderboard views:', err);
    throw err;
  }
};

export default fetchLeaderboardViews;
